import React, { Component, Fragment } from 'react';
import { Card, BreadCrumb, Modal, Confirm } from '../../components';
import { Translate } from '../../contexts/Language';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Config } from '../../config';
import { Service } from '../../services';
import Select from 'react-select';
import { ErrorMessage, Validator } from '../../components/Validator';

export class Rules extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            dataTable: {
                columns: DataTableColumns.transferOptionsRules,
                rows: []
            },
            modal: false,
            modalTitle: "",
            formData: {
                psp: "",
                transferType: "",
                description: ""
            },
            validation: {
                error: false,
                message: ""
            }
        }
        this.pspOptions = [];
        this.typeOptions = [{ value: 'W', label: <span>Withdrawal</span> },
        { value: 'D', label: <span>Deposit</span> }];


        this.onEdit = this.onEdit.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }
    componentDidMount() {
        this.onDatatable();

        Service.TransferOptions.TransferOptionList().then(response => {
            if (response) {
                for (var i = 0; i < response.length; i++) {
                    this.pspOptions.push({ value: response[i].id, label: <span><img src={"/assets/psp-logo/" + (response[i].logo || "defaultlogo.svg")} alt="" width="25" />&nbsp; {response[i].title}</span> });
                }
            }

        });
    }

    onDatatable() {
        Config.utilities.loadingFetch();
        Service.TransferOptions.Rules().then(response => {
            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });

    }

    onNew() {

        this.setState({
            modal: true,
            modalTitle: Translate("Add New Payment Service Rule"),
            formData: {
                ruleId: 0,
                transferType: "",
                psp: "",
                description: "",
            },
            validation: {
                error: false,
                message: ""
            }
        })


    }
    onSave() {
        let formData = this.state.formData;

        if (this.isValid(formData)) {

            Config.utilities.loadingFetch();

            formData.transferType = formData.transferType.value;
            formData.psp = formData.psp.value;
            Service.TransferOptions.RuleSave(formData).then(response => {

                if (response.error) {

                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                }
                else {
                    this.setState({
                        modal: false,
                        formData: {
                            transferType: "",
                            psp: "",
                            description: "",
                            ruleId: 0
                        }
                    })
                    this.onDatatable();
                }
                Config.utilities.loadingFetch();
            });

        }
    }
    isValid(data) {
        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }

    onEdit(id) {
        Config.utilities.loadingFetch();

        Service.TransferOptions.GetRule({ 'id': id }).then(response => {

            if (response) {
                let data = this.state.formData;
                data.description = response.description;
                data.ruleId = response.ruleId;
                data.psp = this.pspOptions.filter(item => item.value === response.id)[0];
                data.transferType = this.typeOptions.filter(item => item.value === response.transferType)[0];

                this.setState({
                    formData: data,
                    modal: true,
                    modalTitle: Translate("Edit Payment Service Rule")
                })
            }

            Config.utilities.loadingFetch();
        });
    }

    onDelete(id) {

        Confirm({
            title: Translate("Are you sure?"),
            type: { warning: true },
            description: Translate("This Transfer Option Rule will be deleted"),
            onConfirm: () => {
                Config.utilities.loadingFetch();
                Service.TransferOptions.DeleteRule({ 'id': id }).then(response => {

                    if (response) {
                        this.setState({
                            validation: response
                        })
                    }

                    this.onDatatable();
                    Config.utilities.loadingFetch();
                });
            },
            onCancel: () => {

            }
        });
    }

    render() {

        return (
            <Fragment>
                <BreadCrumb Title={Translate("PSP Rules")} Name={Translate("PSP Rules")} />

                <Modal Title={this.state.modalTitle} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                    <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                        <ErrorMessage Validation={this.state.validation} />
                        <div className="row">
                            <p className="text-muted mb-2 ml-1 col-md-12 font-12">{Translate("Rule Information")}</p>
                            <div className="col-md-12">
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="transfer-type" className="col-sm-4 col-form-label">{Translate("Transfer Option")}</label>
                                    <div className="col-sm-8">
                                        <Select
                                            id="transfer-type"
                                            value={this.state.formData.psp}
                                            onChange={(e) => this.onFormChange(e, "psp")}
                                            options={this.pspOptions}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="transfer-type" className="col-sm-4 col-form-label">{Translate("Transfer Type Option")}</label>
                                    <div className="col-sm-8">
                                        <Select
                                            id="transfer-type"
                                            value={this.state.formData.transferType}
                                            onChange={(e) => this.onFormChange(e, "transferType")}
                                            options={this.typeOptions}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="transfer-type" className="col-sm-4 col-form-label">{Translate("Description")}</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" id="description" name="description" value={this.state.formData.description} onChange={(e) => this.onFormChange(e.target.value, "description")} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                    <div className="col-sm-8">
                                        <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i>{Translate("Save Form")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal>
                <Card Title="Payment Service Rules" Description="Customer panel payment systems rules.">
                    <div className="row">
                        <div className="col-md-12">
                            <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={(e) => this.onNew()}><i className="fas fa-plus"></i> {Translate("Add New Rule")}</button>
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns(this.onEdit, this.onDelete)}
                                    data={this.state.dataTable.rows}
                                    defaultSortField="id"
                                    defaultSortAsc={false}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>
        )
    }
}